// typescript will throw an error if a new style key is added and it's not configured here
// we could probably be smarter about this by converting the style key name to kebab case
const styleKeyVarMap = {
    core: '',
    utility: '',
    accordion: '--swan-accordion',
    alertBox: '--swan-alert-box',
    anchorBar: '--swan-anchor-bar',
    avatar: '--swan-avatar',
    banner: '--swan-banner',
    button: '--swan-button',
    carousel: '--swan-carousel',
    combobox: '--swan-combobox',
    controlIcon: '--swan-control-icon',
    detailsBanner: '--swan-details-banner',
    embeddedTextHero: '--swan-embedded-text-hero',
    fieldSet: '--swan-fieldset',
    grid: '--swan-grid',
    hidden: '--swan-hidden',
    icon: '--swan-icon',
    legacyCombobox: '--swan-legacy-combobox',
    legacyListbox: '--swan-legacy-listbox',
    legacyModalDialog: '--swan-legacy-modal-dialog',
    legacyPopover: '--swan-legacy-popover',
    listbox: '--swan-listbox',
    menu: '--swan-menu',
    modalDialog: '--swan-modal-dialog',
    pagination: '--swan-pagination',
    popover: '--swan-popover',
    priceBar: '--swan-price-bar',
    pricing: '--swan-pricing',
    progressBar: '--swan-progress-bar',
    progressiveImage: '',
    promoBar: '--swan-promo-bar',
    ratingsStars: '--swan-ratings-stars',
    secondaryTile: '--swan-secondary-tile',
    selectionSet: '--swan-selection-set',
    spinner: '--swan-spinner',
    standardBanner: '--swan-standard-banner',
    standardHero: '--swan-standard-hero',
    standardTile: '--swan-standard-tile',
    stepIndicator: '--swan-step-indicator',
    table: '--swan-table',
    tabs: '--swan-tabs',
    thumbnailsHero: '--swan-thumbnails-hero',
    toggleSwitch: '--swan-toggle-switch',
    visible: '--swan-visible',
    zoomControls: '--swan-zoom-controls'
};

export { styleKeyVarMap };
